import { graphql } from '@e-socna/data-layer';

export const SectionTemplatePage_SectionTemplateVersions_QueryDocument =
  graphql(`
    query SectionTemplatePage_SectionTemplateVersions_Query($originalId: Id!) {
      findAllEditableVersionsForOneOriginalId: findAllSectionTemplateVersionsForOneOriginalId(
        originalId: $originalId
      ) {
        _id
        createdAt
        creatorId
        automaticMemo
        internalMemo
        memo
        version {
          _id
          creatorId
          updaterId
          createdAt
          updatedAt
          contentUpdatedAt

          label
          typeId
          statusId

          # pdfPrints {
          #   _id
          #   increment
          #   fileId
          #   settings {
          #     _id
          #     addHeaders
          #     addFooters
          #     printStyleId
          #   }
          #   isTmp

          #   createdAt
          #   creatorId
          #   updatedAt
          #   updaterId

          #   automaticMemo
          #   internalMemo
          #   memo
          # }
          # pdfPrintsIncrement

          code
          codingConfig {
            _id
            kind
            strategyId
            ... on CodingConfigManual {
              code
            }
          }

          virtualRoot {
            _id
            template {
              _id
              type
            }
            contentOriginId
            isVirtual
            hasPagebreakBefore
            hasPagebreakAfter
            title
            content
            orientation
            paperFormat
            isInsertionPoint
            customLayouts {
              _id
              sectionId
              orientation
              paperFormat
              hasPagebreakAfter
              hasPagebreakBefore
            }
            displayCondition {
              mode
              resolverId
              value
            }

            subSections {
              _id
              template {
                _id
                type
              }

              contentOriginId
              isVirtual
              hasPagebreakBefore
              hasPagebreakAfter
              title
              content
              orientation
              paperFormat
              isInsertionPoint
              customLayouts {
                _id
                sectionId
                orientation
                paperFormat
                hasPagebreakAfter
                hasPagebreakBefore
              }
              displayCondition {
                mode
                resolverId
                value
              }

              subSections {
                _id
                template {
                  _id
                  type
                }
                contentOriginId
                isVirtual
                hasPagebreakBefore
                hasPagebreakAfter
                title
                content
                orientation
                paperFormat
                isInsertionPoint
                customLayouts {
                  _id
                  sectionId
                  orientation
                  paperFormat
                  hasPagebreakAfter
                  hasPagebreakBefore
                }
                displayCondition {
                  mode
                  resolverId
                  value
                }

                subSections {
                  _id
                  template {
                    _id
                    type
                  }
                  contentOriginId
                  isVirtual
                  hasPagebreakBefore
                  hasPagebreakAfter
                  title
                  content
                  orientation
                  paperFormat
                  isInsertionPoint
                  customLayouts {
                    _id
                    sectionId
                    orientation
                    paperFormat
                    hasPagebreakAfter
                    hasPagebreakBefore
                  }
                  displayCondition {
                    mode
                    resolverId
                    value
                  }

                  subSections {
                    _id
                    template {
                      _id
                      type
                    }
                    contentOriginId
                    isVirtual
                    hasPagebreakBefore
                    hasPagebreakAfter
                    title
                    content
                    orientation
                    paperFormat
                    isInsertionPoint
                    customLayouts {
                      _id
                      sectionId
                      orientation
                      paperFormat
                      hasPagebreakAfter
                      hasPagebreakBefore
                    }
                    displayCondition {
                      mode
                      resolverId
                      value
                    }

                    subSections {
                      _id
                      template {
                        _id
                        type
                      }
                      contentOriginId
                      isVirtual
                      hasPagebreakBefore
                      hasPagebreakAfter
                      title
                      content
                      orientation
                      paperFormat
                      isInsertionPoint
                      customLayouts {
                        _id
                        sectionId
                        orientation
                        paperFormat
                        hasPagebreakAfter
                        hasPagebreakBefore
                      }
                      displayCondition {
                        mode
                        resolverId
                        value
                      }

                      subSections {
                        _id
                        template {
                          _id
                          type
                        }
                        contentOriginId
                        isVirtual
                        hasPagebreakBefore
                        hasPagebreakAfter
                        title
                        content
                        orientation
                        paperFormat
                        isInsertionPoint
                        customLayouts {
                          _id
                          sectionId
                          orientation
                          paperFormat
                          hasPagebreakAfter
                          hasPagebreakBefore
                        }
                        displayCondition {
                          mode
                          resolverId
                          value
                        }

                        subSections {
                          _id
                          template {
                            _id
                            type
                          }
                          contentOriginId
                          isVirtual
                          hasPagebreakBefore
                          hasPagebreakAfter
                          title
                          content
                          orientation
                          paperFormat
                          isInsertionPoint
                          customLayouts {
                            _id
                            sectionId
                            orientation
                            paperFormat
                            hasPagebreakAfter
                            hasPagebreakBefore
                          }
                          displayCondition {
                            mode
                            resolverId
                            value
                          }

                          subSections {
                            _id
                            template {
                              _id
                              type
                            }
                            contentOriginId
                            isVirtual
                            hasPagebreakBefore
                            hasPagebreakAfter
                            title
                            content
                            orientation
                            paperFormat
                            isInsertionPoint
                            customLayouts {
                              _id
                              sectionId
                              orientation
                              paperFormat
                              hasPagebreakAfter
                              hasPagebreakBefore
                            }
                            displayCondition {
                              mode
                              resolverId
                              value
                            }

                            subSections {
                              _id
                              template {
                                _id
                                type
                              }
                              contentOriginId
                              isVirtual
                              hasPagebreakBefore
                              hasPagebreakAfter
                              title
                              content
                              orientation
                              paperFormat
                              isInsertionPoint
                              customLayouts {
                                _id
                                sectionId
                                orientation
                                paperFormat
                                hasPagebreakAfter
                                hasPagebreakBefore
                              }
                              displayCondition {
                                mode
                                resolverId
                                value
                              }

                              subSections {
                                _id
                                template {
                                  _id
                                  type
                                }
                                contentOriginId
                                isVirtual
                                hasPagebreakBefore
                                hasPagebreakAfter
                                title
                                content
                                orientation
                                paperFormat
                                isInsertionPoint
                                customLayouts {
                                  _id
                                  sectionId
                                  orientation
                                  paperFormat
                                  hasPagebreakAfter
                                  hasPagebreakBefore
                                }
                                displayCondition {
                                  mode
                                  resolverId
                                  value
                                }

                                subSections {
                                  _id
                                  template {
                                    _id
                                    type
                                  }
                                  contentOriginId
                                  isVirtual
                                  hasPagebreakBefore
                                  hasPagebreakAfter
                                  title
                                  content
                                  orientation
                                  paperFormat
                                  isInsertionPoint
                                  customLayouts {
                                    _id
                                    sectionId
                                    orientation
                                    paperFormat
                                    hasPagebreakAfter
                                    hasPagebreakBefore
                                  }
                                  displayCondition {
                                    mode
                                    resolverId
                                    value
                                  }
                                }
                              }
                            }
                          }
                        }
                      }
                    }
                  }
                }
              }
            }
          }
        }
      }
    }
  `);
